/**
 * @file GDotObjFieldContainer.jsx
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jun 27, 2024 13:33
 */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import GDotObjField from './GDotObjField';
import { objectDeepCopy, objectExists, stringExists } from 'src/@common/utilities';

function GDotObjFieldContainer(props) {
    const {
        containerSxStyle = { maxWidth: '255px' },
        gDotObj,
        handleBlur = () => { },
    } = props;

    const [fieldErrors, setFieldErrors] = useState({});
    const [formFields, setFormFields] = useState({});
    const [formIsDirty, setFormIsDirty] = useState(false);

    useEffect(() => {
        // initalize the local form fields
        let localObj = {};

        if (objectExists(gDotObj)) {
            localObj = objectDeepCopy(gDotObj);
            setFormFields(localObj);

            // if (!stringExists(gDotObj.hg38.gDot)) {
            //     setFieldErrors({
            //         'hg38.gDot': 'Required!',
            //     });
            // } else {
            //     setFieldErrors({
            //         'hg38.gDot': '',
            //     });
            // }
        }
    }, [gDotObj]);

    // local utility function
    const convertToUCase = (value) => {
        let result = '';
        if (value.toUpperCase) {
            result = value.toUpperCase();
            result = result.replace('G.', 'g.');
        }
        return result;
    };

    const fieldUpdater = (fieldName, value) => {

        // updates localState only
        if (fieldName) {
            const tmpFields = objectDeepCopy(formFields);

            switch (fieldName) {
                case 'hg19.gDot':
                    tmpFields.hg19.gDot = value;
                    setFormFields(tmpFields);
                    setFormIsDirty(true);
                    break;
                case 'hg38.gDot':
                    tmpFields.hg38.gDot = value;
                    setFormFields(tmpFields);
                    setFormIsDirty(true);
                    break;
                default:
                    setFormFields({
                        ...formFields,
                        [fieldName]: value
                    });
                    setFormIsDirty(true);
                    break;
            }
        }
    };

    const handleChange = (event, fieldName) => {

        let str = null;

        if (event) {
            if (event.target.type) {

                const value = event.target.value;

                switch (event.target.type) {
                    case 'autocomplete':
                    case 'text':
                        switch (fieldName) {
                            default:
                                if (value) {
                                    str = value;
                                } else {
                                    str = '';
                                }
                                break;
                        }
                        break;

                    default:
                        str = value;
                        break;
                }

                if (str) {

                    // convert everything but 'g.' to uppercase
                    if (str.toUpperCase) {
                        // str = str.toUpperCase();
                        // str = str.replace('G.', 'g.');
                    }
                }

                // set the updated value in state
                fieldUpdater(fieldName, str);
            }
        }

    };

    const validateField = (fieldName, value) => {

        const isValid = true;

        if (fieldName) {
            let msg = '';

            if (stringExists(value)) {
                if (!value.includes('g.')) {
                    msg = "must have: 'g.' prefix";
                } else {
                    const idx = value.indexOf('g.');
                    if (idx !== 0) {
                        msg = "must have: 'g.' prefix";
                    }
                }
            }

            switch (fieldName) {
                case 'hg19.gDot':
                    setFieldErrors({
                        'hg19.gDot': msg,
                    })
                    break;

                case 'hg38.gDot':
                    setFieldErrors({
                        'hg38.gDot': msg,
                    });

                    break;

                default:
                    break;
            }
        }

        return isValid;
    };

    const localHandleBlur = (fieldName) => {

        if (formIsDirty === true) {

            let value = '';

            switch (fieldName) {
                case 'hg19.gDot':
                    value = formFields.hg19.gDot;
                    break;
                case 'hg38.gDot':
                    value = formFields.hg38.gDot;
                    break;
                default:
                    break;
            }

            const isValid = validateField(fieldName, value);

            if (isValid === true) {
                // reformat

                // convert everything but 'g.' to uppercase
                formFields.hg19.gDot = convertToUCase(formFields.hg19.gDot);
                formFields.hg38.gDot = convertToUCase(formFields.hg38.gDot);

                // formFields are sent to update parent state
                handleBlur(formFields);

                setFormIsDirty(false);
            }

        }
    };

    return <GDotObjField
        containerSxStyle={containerSxStyle}
        fieldErrors={fieldErrors}
        formFields={formFields}
        handleBlur={localHandleBlur}
        handleChange={handleChange}
    />
}

GDotObjFieldContainer.propTypes = {
    containerSxStyle: PropTypes.object,
    gDotObj: PropTypes.object,
    handleBlur: PropTypes.func.isRequired,
};

export default GDotObjFieldContainer;